module.exports = __webpack_public_path__ + "static/media/pottery.c66232c7.jpg";